define((require) => {
    "use strict";

    var ImprovedView = require("editor/zbone/ImprovedView"),
        template     = require("ui/experience/action/js/JsActionPropertiesView.tpl");

    /**
     * Properties view for a javascript action.
     *
     * @class JsActionPropertiesView
     * @constructor
     *
     * @cfg {JsAction} model The action to display in the view.
     */
    return ImprovedView.extend({
        template: template,

        bindings: {
            ".code": "code"
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/experience/action/js/JsActionPropertiesView.js